import React from 'react';
import { Redirect } from 'react-router-dom';
import { get } from 'lodash';
import { isPhone } from 'utils/mobileDetect';
import TransitionedPage from '../components/common/transitionedPage/TransitionedPage';

export default class RoutesUtil {
  static renderRoute(item, props) {
    const prevSearch = get(props, 'location.search');
    const isMobileVersion = isPhone();

    if (item.redirect) {
      return (
        <Redirect to={{
          pathname: item.redirect,
          state: Object.assign({}, item.props, { prevSearch }) }}
        />
      );
    }

    return (
      React.createElement(
        item.transition ? TransitionedPage(item.component) : item.component,
        Object.assign(
          { isMobile: isMobileVersion },
          props,
          item.props,
        ),
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/RoutesUtils.class.js